export const OBTENER_ARCHIVOS_DOWNLOAD_DATA     = 'OBTENER_ARCHIVOS_DOWNLOAD_DATA'
export const REGISTER_USERS_CONNECTED_MODULES   = 'REGISTER_USERS_CONNECTED_MODULES'
export const DATA_DOWNLOAD_SELECTED             = 'DATA_DOWNLOAD_SELECTED'
export const FILTERS_DOWNLOAD_DATA              = 'FILTERS_DOWNLOAD_DATA'